import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            热门剧集
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            精彩剧集
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            高清完整版热门剧集一网打尽，从宫斗经典到古装权谋，吃瓜视频为你精选
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 吃瓜视频高清在线观看`}
                  title={`${item.title} 完整版高清播放`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`${item.tagColor} text-white text-xs font-semibold px-2.5 py-1 rounded-full`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-2 py-0.5 rounded">
                  {item.rating}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1 mb-3">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#index"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-600 font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-colors duration-200"
          >
            查看更多剧集
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}